<template>
  <div class="mx-3">
    <v-row>
      <v-col>
        <v-card class="pa-4">
          <v-row>
            <v-col
              cols="12"
              class="pb-1"
            >
              <v-card-title class="pa-0">
                Leave Lock Setup
              </v-card-title>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    v-validate="'required'"
                    label="Start Lock Date"
                    :error-messages="errors.collect('startDate')"
                    data-vv-name="startDate"  
                    data-vv-as="start date"    
                    readonly
                    outlined
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  :min="this.$moment().format('YYYY-MM-DD')"
                  @input="startDateOnChanged()"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    v-validate="'required'"
                    :disabled="!startDate"
                    label="End Lock Date"
                    :error-messages="errors.collect('endDate')"
                    data-vv-name="endDate"  
                    data-vv-as="end date"    
                    readonly
                    outlined
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  :disabled="!startDate"
                  no-title
                  :min="startDate ? startDate : this.$moment().format('YYYY-MM-DD')"
                  @input="endDateMenu = false, leaveTypeListChange()"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <!-- list all leave types -->
              <v-data-table
                v-model="leaveTypesList"
                v-validate="'required'"
                :error-messages="errors.collect('leaveTypesList')"
                data-vv-name="leaveTypesList"
                data-vv-as="leave types"
                :loading="leaveTypesTableLoading"
                :headers="leaveTypesHeaders"
                dense
                :items="filteredLeaveTypes"
                hide-default-footer
                fixed-header
                disable-pagination
                class="elevation-1 mb-3"
                show-select
                item-key="id"
                item-value="name"
              >
                <template v-slot:item.name="{ item }">
                  <div class="my-2">
                    {{ item.name }}
                  </div>
                </template>
              </v-data-table>
              <div :class="errors.first('leaveTypesList') ? 'py-0' : 'py-3'">
                <span class="red--text text--lighten-1 caption">{{ errors.first('leaveTypesList') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row
            v-if="$hasPermissionTo(['create leave lock settings'])"
            no-gutters
          >
            <v-col>
              <v-card-actions class="py-0">
                <v-spacer />
                <v-btn
                  :disabled="resetFormProgressing"
                  text
                  class="px-10"
                  @click="resetForm"
                >
                  Reset
                </v-btn>
                <v-btn
                  :loading="submitFormProgressing"
                  color="hrissecondary"          
                  class="white--text px-10"
                  @click="submitForm"  
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="pa-4">
          <v-row>
            <v-col>
              <v-card-title class="pa-0">
                Leave Lock History
              </v-card-title>
            </v-col>
            <v-col
              md="4"
              xl="4"
              class="pt-0"
            >
              <v-autocomplete
                v-model="yearFilter"
                :items="leaveLockSettingYears"
                hide-no-data
                hide-selected
                label="Year Filter"
                @change="loadData()"
              />
            </v-col>
            
            <!-- <v-col
              md="4"
              xl="4"
              class="pt-0"
            >
              <v-autocomplete
                v-model="leaveTypeFilter"
                :items="leaveTypes"
                multiple
                item-text="name"
                item-value="id"
                hide-no-data
                chips
                small-chips
                deletable-chips
                hide-selected
                label="Leave Type Filter"
                placeholder="Choose leave type"
                @change="loadData()"
              />
            </v-col> -->
          </v-row>
          <!-- list all leave lock settings data -->
          <v-data-table
            v-model="leaveLockSettingsList"
            :loading="leaveLockSettingsTableLoading"
            :headers="leaveLockSettingsHeaders"
            dense
            :items="leaveLockSettings"
            fixed-header
            class="elevation-1 mb-3 mt-3"
            :items-per-page="15"
          >
            <template v-slot:item.action="{ item }">
              <setup-leaves-leave-lock-dialog-delete
                v-if="$hasPermissionTo(['delete leave lock settings'])"
                :leave-lock-setting="item"
                @deleted="loadData()"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {  
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      SetupLeavesLeaveLockDialogDelete: () => import('@/components/hris/setup/leaves/leave-lock/DialogDelete'),
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        endDateMenu: false,
        endDate: null,
        leaveTypesList: null,
        leaveTypes: [],
        leaveTypesTableLoading: false,
        leaveTypesHeaders: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
          },      
        ],
        leaveLockSettingsList: null,
        leaveLockSettings: [],
        leaveLockSettingsTableLoading: false,
        leaveLockSettingsHeaders: [
          {
            text: 'Leave Type',
            align: 'left',
            sortable: true,
            value: 'leave_type.name',
          },   
          {
            text: 'Start Lock Date',
            align: 'left',
            sortable: true,
            value: 'start_date',
          },   
          {
            text: 'End Lock Date',
            align: 'left',
            sortable: true,
            value: 'end_date',
          },
          {
            text: '',
            align: 'left',
            sortable: false,
            value: 'action',
          },
        ],
        resetFormProgressing: false,
        submitFormProgressing: false,
        leaveLockSettingYears: [],
        yearFilter: (new Date()).getFullYear(),
        leaveTypeFilter: [],
        excludedLeaveTypes: [],
      }
    },
    computed: {
      filteredLeaveTypes () {
        if (!this.startDate) {
          return this.leaveTypes
        }

        return this.leaveTypes.filter(leaveType => {
          return !this.excludedLeaveTypes.includes(leaveType.id)
        })
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.submitFormProgressing = true

            this.$api.leaveLockSettings().create(this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'Leave lock settings created successfully' })
                this.resetForm()
                this.submitFormProgressing = false
              }).catch(() => {
                this.submitFormProgressing = false
                this.$snack({ color: 'red', message: 'Error. Please contact IT Support' })
              })
          })
      },
      loadData () {
        this.leaveTypesTableLoading = true
        this.leaveLockSettingsTableLoading = true

        Promise.all([
          this.$api.hrisLeaveTypes().list(),
          this.$api.leaveLockSettings().distinctYear(),
          this.$api.leaveLockSettings().yearFilteredList(this.yearFilter),
        ]).then(([leaveTypes, leaveLockYears, leaveLockSettings]) => {
          this.leaveTypes = leaveTypes.data
          this.leaveLockSettingYears = leaveLockYears.data
          this.leaveLockSettings = leaveLockSettings.data

          this.leaveTypesTableLoading = false
          this.leaveLockSettingsTableLoading = false

          this.tableLoading = false
        })
      },
      startDateOnChanged () {
        this.startDateMenu = false
        if (!this.endDate || this.endDate < this.startDate) {
          this.endDate = this.startDate
        }
        
        this.leaveTypeListChange()
      },
      leaveTypeListChange () {
        this.excludedLeaveTypes = []
        this.leaveLockSettings.map(lock => {
          if ((lock.start_date <= this.startDate && lock.end_date >= this.startDate) ||
            (lock.start_date <= this.endDate && lock.end_date >= this.endDate)) {
            this.excludedLeaveTypes.push(lock.leave_type.id)
          }
          if (lock.start_date >= this.startDate && lock.end_date <= this.endDate) {
            if (!this.excludedLeaveTypes.includes(lock.leave_type.id)) {
              this.excludedLeaveTypes.push(lock.leave_type.id)
            }
          }
        })
      },
      prepareFormData () {
        return {
          selected_leave_types: this.leaveTypesList,
          start_date: this.startDate,
          end_date: this.endDate,
        }
      }, 
      resetForm () {
        this.$validator.reset()
        this.resetFormProgressing = true
        this.startDateMenu = false
        this.startDate = null
        this.endDateMenu = false
        this.endDate = null
        this.leaveTypesList = []
        this.loadData()
        this.resetFormProgressing = false
      },
    },
  }
</script>
<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
